import { connect } from 'react-redux'
import ServiceCreateHeader from '../../components/services/edit/ServiceCreateHeader'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    steps: state.serviceEdit.steps.list,
    currentStep: state.serviceEdit.steps.currentStep
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceCreateHeader)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceCreateHeader.ts